import { Head } from "@pjs/utilities";
import { INotificationModel, ISettingOption } from "@pjs/user-domain";
import { userUiI18n } from "../../i18n/UserUiI18n.const";
import { IMappedNotifications } from "../interfaces/IMappedNotifications";
import { IAppNotification } from "../interfaces/IAppNotification";

export const getNotificationValues = (notifications: INotificationModel): IMappedNotifications => {
    const notificationsKeys = Object.keys(notifications.settings);
    const notificationSettings: Array<IAppNotification> = [];

    const notificationStrings: { [key: string]: Head<Parameters<typeof userUiI18n.getString>> } = {
        gradesTitle: "notifications.pref_notification_grades.title",
        gradesSubTitle: "notifications.pref_notification_grades.sub_title",
        feedbackTitle: "notifications.pref_notification_feedback.title",
        feedbackSubTitle: "notifications.pref_notification_feedback.sub_title",
        commentsTitle: "notifications.pref_notification_comments.title",
        commentsSubTitle: "notifications.pref_notification_comments.sub_title",
        updatedTitle: "notifications.pref_notification_updated.title",
        updatedSubTitle: "notifications.pref_notification_updated.sub_title",
        sharesTitle: "notifications.pref_notification_shares.title",
        sharesSubTitle: "notifications.pref_notification_shares.sub_title",
        atlasreceiptsTitle: "notifications.pref_notification_atlas_receipts.title",
        atlasreceiptsSubTitle: "notifications.pref_notification_atlas_receipts.sub_title"
    };

    notificationsKeys.forEach((key: string) => {
        if (key !== "notificationFrequency" && key !== "notificationTime") {
            notificationSettings.push({
                type: key,
                title: userUiI18n.getString(notificationStrings[`${notifications.settings[key].name.split(".")[2].toLowerCase()}Title`]),
                subTitle: userUiI18n.getString(notificationStrings[`${notifications.settings[key].name.split(".")[2].toLowerCase()}SubTitle`]),
                settings: {
                    digest: notifications.settings[key].value.includes("D"),
                    email: notifications.settings[key].value.includes("E"),
                    feed: notifications.settings[key].value.includes("F")
                }
            });
        }
    });

    let timeIndex = 0;
    let frequencyIndex = 0;

    const timeOptions =
        notifications.settings.notificationTime.options !== undefined
            ? notifications.settings.notificationTime.options.map((value, index: number) => {
                  if (value === notifications.settings.notificationTime.value) {
                      timeIndex = index;
                  }

                  return {
                      value: (Number(value) < 10 ? "0" : "") + `${value}:00`
                  };
              })
            : [];

    const frequencyOptions =
        notifications.settings.notificationFrequency.options !== undefined
            ? notifications.settings.notificationFrequency.options.map((item: ISettingOption, index: number) => {
                  if (item.key === notifications.settings.notificationFrequency.value) {
                      frequencyIndex = index;
                  }

                  return {
                      value: item.value
                  };
              })
            : [];

    return {
        digestIsDisabled: notifications.digestIsDisabled,
        digestSettings: {
            time: {
                name: notifications.settings.notificationTime.name,
                options: timeOptions,
                index: timeIndex
            },
            frequency: {
                name: notifications.settings.notificationFrequency.name,
                options: frequencyOptions,
                index: frequencyIndex
            }
        },
        notificationSettings: notificationSettings
    };
};
